/**
 * ENV OF Normal access vs Demo Environment
 */
export const ENV = {
  PRODUCTION: 'production',
  STAGING: 'staging',
};

/**
 * Refer to .env file, differentiate between
 * apps on prod and development mode
 */
export const DOMAIN_ENV = {
  PRODUCTION: 'prod',
  STAGING: 'staging',
};
